const INCOME_PARAMS = [
  "incomeSalary",
  "incomePension",
  "incomeAlimony",
  "incomeProperties",
  "expenseInsurance",
  "expenseAlimony",
  "expenseInterest",
];

/**
 * Check whether the stringified version of the
 * @param {Object} data Output from IncomeConfigurator
 * @returns {Array}
 */
function serializeIncome(income) {
  let serialized = INCOME_PARAMS.map((param) => income[param] || 0);

  // Check whether we have any non-zero values after the first one
  const isExact = !!serialized.slice(1).find(Boolean);

  // If we are _not_ in exaxt mode, we send the first value only
  if (!isExact) {
    serialized = serialized.slice(0, 1);
  }

  return serialized;
}

/**
 * Calculate effective income from inputs
 * @param {Object} data Output from IncomeConfigurator
 * @param {Number} data.incomeSalary
 * @param {Number} data.incomePension
 * @param {Number} data.incomeAlimony
 * @param {Number} data.incomeProperties
 * @param {Number} data.expenseInsurance
 * @param {Number} data.expenseAlimony
 * @param {Number} data.expenseInterest
 * @returns {Number}
 */
function calculateIncome({
  incomeSalary,
  incomePension,
  incomeAlimony,
  incomeProperties,
  expenseInsurance,
  expenseAlimony,
  expenseInterest,
}) {
  const isExact = !!(
    incomePension ||
    incomeAlimony ||
    incomeProperties ||
    expenseInsurance ||
    expenseAlimony ||
    expenseInterest
  );

  let result = 0;

  if (isExact) {
    const bvg =
      incomeSalary > 21150 ? Math.max(incomeSalary - 24675, 3525) * 0.065 : 0;
    const netSalary = incomeSalary * (1 - 0.07225) - bvg;
    const deduction = Math.max(Math.min(0.05 * netSalary, 6000), 2700);
    const deductionInsurance = netSalary > 28000 ? 2400 : 2600;

    result =
      netSalary +
      incomePension +
      incomeAlimony +
      incomeProperties -
      expenseInsurance -
      expenseAlimony -
      expenseInterest -
      deduction -
      deductionInsurance;
  } else {
    const netSalary = 0.8643 * incomeSalary;

    result = netSalary - 13547;
  }

  result = Math.max(0, Math.round(result));

  return result;
}

export { INCOME_PARAMS, calculateIncome, serializeIncome };
